import React, { useEffect, useState } from 'react';
import { useUser } from '../context/UserContext';
import { format } from 'date-fns';

const SupplierHistory = () => {
  const { authFetch } = useUser();
  const [dishes, setDishes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const data = await authFetch('/supplier/dishes');
        const sorted = [...(data || [])].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setDishes(sorted);
      } catch (err) {
        console.error('Ошибка при загрузке истории:', err);
        setError('Не удалось загрузить историю блюд.');
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, [authFetch]);

  if (loading) return <p className="text-white text-center">Загрузка истории...</p>;
  if (error) return <p className="text-red-400 text-center">{error}</p>;
  if (dishes.length === 0) return <p className="text-gray-400 text-center">История пуста. Вы ещё не сохраняли блюда.</p>;

  return (
    <div className="text-white space-y-6">
      <h2 className="text-xl font-bold text-teal-400 text-center">История блюд</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-gray-800 border border-gray-600 rounded shadow-md">
          <thead>
            <tr className="bg-gray-700 text-gray-300 text-sm uppercase">
              <th className="px-4 py-2">Название</th>
              <th className="px-4 py-2">Цена</th>
              <th className="px-4 py-2">Класс блюда</th>
              <th className="px-4 py-2">Даты</th>
              <th className="px-4 py-2">Время</th>
              <th className="px-4 py-2">Фото</th>
            </tr>
          </thead>
          <tbody>
            {dishes.map((dish, index) => (
              <tr key={index} className="border-t border-gray-700 text-sm">
                <td className="px-4 py-2">{dish.name}</td>
                <td className="px-4 py-2">{dish.price} ₽</td>
                <td className="px-4 py-2">{dish.dishClass || '-'}</td>
                <td className="px-4 py-2 text-xs text-gray-400">{dish.days?.join(', ') || '—'}</td>
                <td className="px-4 py-2 text-xs text-gray-400">
                  {dish.createdAt ? format(new Date(dish.createdAt), 'dd.MM.yyyy HH:mm') : '—'}
                </td>
                <td className="px-4 py-2">
                  {dish.imageUrl ? (
                    <img
                      src={dish.imageUrl}
                      alt="preview"
                      className="w-20 h-20 object-cover rounded border border-gray-600"
                    />
                  ) : (
                    <span className="text-xs text-gray-500">Нет фото</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SupplierHistory;
